import React, { useState } from "react";
import { Film, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";

const MAX = 150 * 1024 * 1024;

export const VideoUploader = ({ files = [], onFiles }) => {
  const [progress, setProgress] = useState(null);

  const upload = async (file) => {
    if (!file.type.startsWith("video/")) return toast.error("Solo se permiten vídeos");
    if (file.size > MAX) return toast.error("El vídeo supera 150 MB");
    setProgress(0);
    try {
      const { data } = await api.post("/me/onboarding/videos/init", { filename: file.name, size: file.size, content_type: file.type });
      for (let off = 0; off < file.size; off += data.chunk_size) {
        const chunk = file.slice(off, off + data.chunk_size);
        await api.put(`/me/onboarding/videos/${data.id}/chunk`, chunk, { headers: { "Content-Type": "application/octet-stream" } });
        setProgress(Math.round(((off + chunk.size) / file.size) * 100));
      }
      const done = (await api.post(`/me/onboarding/videos/${data.id}/complete`)).data;
      onFiles([...files, done]);
      toast.success("Vídeo subido");
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setProgress(null);
    }
  };

  const remove = async (id) => {
    try { await api.delete(`/me/onboarding/videos/${id}`); onFiles(files.filter((f) => f.id !== id)); }
    catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }} data-testid="onb-videos">
      {files.map((f) => (
        <div key={f.id} className="emp-opt" style={{ cursor: "default" }} data-testid={`onb-video-${f.id}`}>
          <Film size={16} />
          <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.original_filename}</span>
          <span style={{ fontSize: 12, color: "#737373" }}>{(f.size / 1048576).toFixed(1)} MB</span>
          <button type="button" onClick={() => remove(f.id)} style={{ background: "none", border: "none", color: "#a3a3a3", cursor: "pointer" }} aria-label="Eliminar vídeo"><Trash2 size={16} /></button>
        </div>
      ))}
      {progress !== null ? (
        <div className="emp-opt" style={{ cursor: "default" }} data-testid="onb-video-progress">
          Subiendo… {progress}%
          <div className="emp-progress" style={{ flex: 1 }}><div style={{ width: `${progress}%` }} /></div>
        </div>
      ) : (
        <label className="emp-opt" style={{ justifyContent: "center", minHeight: 52 }} data-testid="onb-video-add">
          <Upload size={16} /> Subir vídeo
          <input type="file" accept="video/*" style={{ display: "none" }} onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) upload(f); }} />
        </label>
      )}
    </div>
  );
};
